
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import { useState } from "react";
import Select from "react-select";
import { Country} from "country-state-city";



export default function ContactSection({
  data,
  errors,
  onChange,
  isEdit,
}) {
    const [showPassword, setShowPassword] = useState(false);

    const selectStyles = {
    control: (base, state) => ({
      ...base,
      minHeight: "48px",
      height: "48px",
      borderRadius: "0.75rem",
      borderColor: state.isFocused ? "#c7d2fe" : "#d1d5db",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#a5b4fc",
      },
    }),
    valueContainer: (base) => ({
      ...base,
      height: "48px",
      padding: "0 12px",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "48px",
    }),
  };

    const countryOptions = Country.getAllCountries();

    const countryCodeOptions = countryOptions.map((c) => ({
  value: `+${c.phonecode}`,
  label: `${c.flag} +${c.phonecode} (${c.name})`,
  }));

  return (
    <>
      <div>
        <label className="mb-1 block text-sm font-medium">
          Phone Number <span className="text-red-500">*</span>
        </label>
        <div className="flex">
         <Select
              options={countryCodeOptions}
              value={countryCodeOptions.find(
                (c) => c.value === data.country_code
              )}
              onChange={(option) =>
                onChange({
                  target: {
                    name: "country_code",
                    value: option.value,
                  },
                })
              }
              isSearchable
              classNamePrefix="react-select"
              styles={selectStyles}
            />
          <input
            type="text"
            name="phone_number"
            value={data.phone_number}
            onChange={onChange}
            className={`flex-1 rounded-r-xl border p-3 ${
              errors.phone_number ? "border-red-400" : "border-gray-300"
            }`}
          />
        </div>
        {errors.phone_number && (
          <p className="mt-1 text-xs text-red-500">
            {errors.phone_number}
          </p>
        )}
      </div>

      <div>
        <label className="mb-1 block text-sm font-medium">
          Email <span className="text-red-500">*</span>
        </label>
        <input
          type="email"
          name="email"
          value={data.email}
          onChange={onChange}
          className={`w-full rounded-xl border p-3 ${
            errors.email ? "border-red-400" : "border-gray-300"
          }`}
        />
        {errors.email && (
          <p className="mt-1 text-xs text-red-500">{errors.email}</p>
        )}
      </div>

        <div>
          <label className="mb-1 block text-sm font-medium">
            Password <span className="text-red-500">*</span>
          </label>
          <div className="relative">
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            value={data.password}
            onChange={onChange}
            className={`w-full rounded-xl border p-3 ${
              errors.password ? "border-red-400" : "border-gray-300"
            }`}
          />
          <button
                        type="button"
                        onClick={() => setShowPassword((p) => !p)}
                        className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500"
                      >
                        {showPassword ? (
                          <MdVisibility size={20} />
                        ) : (
                          <MdVisibilityOff size={20} />
                        )}
                      </button>
                      </div>
          {errors.password && (
            <p className="mt-1 text-xs text-red-500">
              {errors.password}
            </p>
          )}
        </div>


      <div>
        <label className="mb-1 block text-sm font-medium">Website</label>
        <input
          type="text"
          name="website"
          value={data.website}
          onChange={onChange}
          className={`w-full rounded-xl border p-3 ${
            errors.website ? "border-red-400" : "border-gray-300"
          }`}
        />
        {errors.website && (
          <p className="mt-1 text-xs text-red-500">{errors.website}</p>
        )}
      </div>

      <div>
        <label className="mb-1 block text-sm font-medium">
          Manager Name
        </label>
        <input
          type="text"
          name="manager_name"
          value={data.manager_name}
          onChange={onChange}
          className={`w-full rounded-xl border p-3 ${
            errors.manager_name ? "border-red-400" : "border-gray-300"
          }`}
        />
        {errors.manager_name && (
          <p className="mt-1 text-xs text-red-500">
            {errors.manager_name}
          </p>
        )}
      </div>

      <div>
        <label className="mb-1 block text-sm font-medium">
          Manager Email
        </label>
        <input
          type="email"
          name="manager_email"
          value={data.manager_email}
          onChange={onChange}
          className={`w-full rounded-xl border p-3 ${
            errors.manager_email ? "border-red-400" : "border-gray-300"
          }`}
        />
        {errors.manager_email && (
          <p className="mt-1 text-xs text-red-500">
            {errors.manager_email}
          </p>
        )}
      </div>
    </>
  );
}
